import React, { useState } from "react";
import { Box, Drawer, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import SemicircularChart from "../../../common/AnalyticsComponents/SemicircularChart";
import PriorityBreakdown from "../../../common/AnalyticsComponents/PriorityBreakdown";
import StatusBadgeRow from "../../../common/AnalyticsComponents/StatusBadgeRow";
import { taskAnalyticsContentEnum } from "../../../utils/constant";
import Resource from "./Drawer/Resource";
const TaskAnalytics = ({
  taskTabValue,
  selectedTaskGroup,
  selectedTaskmember,
  isSideBarOpen,
  isTopicOpen,
}) => {
  const taskAnalyticsData = useSelector(
    (state) => state?.arkchatgroup?.taskAnalyticsData,
  );
  const [isResourceUtilisationOpen, setResourceUtilisationOpen] =
    useState(false);
  return (
    <Box>
      <Box mt={"0.1rem"} mb={"0.1rem"}>
        <Box>
          {/* <Button
            style={{
              background: "#DB0011",
              color: "white",
              borderRadius: "3px",
              textTransform: "none",
              minWidth: "9.5rem",
            }}
            variant="contained"
            onClick={() => setResourceUtilisationOpen(true)}
          >
            Time sheet
          </Button> */}
          <Drawer
            sx={{ zIndex: 1202 }}
            open={isResourceUtilisationOpen}
            anchor="right"
          >
            <Resource
              taskTabValue={taskTabValue}
              setResourceUtilisationOpen={setResourceUtilisationOpen}
              selectedTaskGroup={selectedTaskGroup}
              selectedTaskmember={selectedTaskmember}
            />
          </Drawer>
        </Box>

        {/* <Box
          sx={{
            overflowX: "auto",
            gap: "0.5rem",
            display: "flex",
            "&::-webkit-scrollbar": {
              height: "2px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#F9F8F8",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "grey",
            },
          }}
        >
          {taskAnalyticsData?.groupData?.map((groupAnalyticsData) => (
            <Box display={"inline-flex"} gap={"0.5rem"} mt={"0.1rem"}>
              <Typography fontSize={"1rem"}>
                {groupAnalyticsData?.name}
              </Typography>
              <Box
                display={"flex"}
                border={"1px solid"}
                bgcolor={"rgba(0, 127, 143, 1)"}
                color={"#fff"}
                padding={"0.1rem 0.5rem"}
                gap={"0.4rem"}
              >
                <Typography>
                  {groupAnalyticsData?.analysis_time?.timeValue}
                </Typography>
                <Typography>
                  {groupAnalyticsData?.analysis_time?.timeType}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box> */}
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            // 3 cols when sidebar + topics panel are both open (narrower viewport)
            md: isSideBarOpen && isTopicOpen ? "repeat(3, 1fr)" : "repeat(4, 1fr)",
          },
          gap: "0.75rem",
          mt: "0.1rem",
        }}
      >
        {taskAnalyticsData?.analyticsData?.map((data) => (
          <Box
            sx={{
              borderRadius: "8px",
              border: "1px solid rgba(232, 232, 232, 1)",
              boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
              padding: "0.75rem 0.8rem 0.85rem",
              backgroundColor: "#fff",
              display: "flex",
              flexDirection: "column",
            }}
            key={data?.status + "TaskAnalyticsData"}
          >
            {/* Card title */}
            <Typography
              textAlign={"center"}
              fontWeight={700}
              fontSize={"0.92rem"}
              color={"#111"}
              mb={"0.3rem"}
            >
              {taskAnalyticsContentEnum[data?.status]?.title}
            </Typography>

            {/* Radial donut chart */}
            <SemicircularChart
              trackBackground={
                taskAnalyticsContentEnum[data?.status]?.backgroundColor
              }
              colorsData={taskAnalyticsContentEnum[data?.status]?.color}
              seriesData={
                data?.total !== 0
                  ? Math.floor((data?.count / data?.total) * 100)
                  : 0
              }
              centerLabel={data?.status === "total" ? data?.count : undefined}
            />

            {/* On Time / After Delay / Reopened badges — below the chart */}
            {data?.status === "done" && (
              <StatusBadgeRow
                badges={[
                  { label: "On Time", value: data?.onTime ?? 0 },
                  { label: "After Delay", value: data?.afterDelay ?? 0 },
                  { label: "Reopened", value: data?.reopened ?? 0 },
                ]}
              />
            )}

            {/* Priority label + bars */}
            <Typography
              textAlign={"center"}
              fontSize={"0.78rem"}
              color={"#888"}
              mt={"0"}
              mb={"0.4rem"}
            >
              Priority
            </Typography>
            <PriorityBreakdown priority={data?.priority} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default TaskAnalytics;
